/**
 * If one of the storage functions throws, the error object will
 * have a code property that contains one of these values, and the
 * message property will have a message suitable for debug purposes.
 */
export var StorageErrorType;
(function (StorageErrorType) {
    /**
     * The key is null or empty.
     */
    StorageErrorType[StorageErrorType["missingKey"] = 0] = "missingKey";
    /**
     * `get()` found the data, but it is corrupted.
     */
    StorageErrorType[StorageErrorType["invalidData"] = 1] = "invalidData";
    /**
     * A system-level error occurred when getting/setting data from/to the store.
     */
    StorageErrorType[StorageErrorType["osError"] = 2] = "osError";
    /**
     * An unclassified system-level error occurred.
     */
    StorageErrorType[StorageErrorType["unknownError"] = 3] = "unknownError";
})(StorageErrorType || (StorageErrorType = {}));
